import switchLoginCom from './switchLogin';
export default {
  install (Vue, opts) {
    const SwitchLoginExtend = Vue.extend(switchLoginCom);
    let view = null;
    function switchL (options) {
      if (!view) {
        view = new SwitchLoginExtend();
        view.$mount();
        document.querySelector('body').appendChild(view.$el);
      }
      view.show(options);
    }
    function cancle () {
      view.hide();
    }
    const switchLogin = {
      init: switchL,
      hide: cancle
    };
    Vue.prototype.$SwitchLogin = switchLogin;
  }
};
